import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  WITHHOLDING_REPOSITORY,
  WithholdingRepository
} from '@app/domain/repositories/ptrab/withholding/withholding.repository.contract';
import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { PortugueseWithholding, Withholding } from '@app/entities/models/ptrab/withholding/withholding.model';

import { WithholdingUseCases } from './withholding.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class WithholdingUseCasesImpl implements WithholdingUseCases {
  #withholdingRepository: WithholdingRepository = inject(WITHHOLDING_REPOSITORY);

  getWithholdingList(): Observable<Withholding[]> {
    return this.#withholdingRepository.getWithholdingList();
  }

  editWithholding(withholding: Withholding, twoFactorAuthorization: TwoFactorAuthorization): Observable<Withholding> {
    return this.#withholdingRepository.editWithholding(withholding, twoFactorAuthorization);
  }

  getPortugueseWithholdingList(isEmployee: boolean): Observable<PortugueseWithholding> {
    return this.#withholdingRepository.getPortugueseWithholdingList(isEmployee);
  }

  onError(): Observable<ErrorMsgEnum> {
    return this.#withholdingRepository.onError$;
  }
}
